import { TextInput } from '@obvio/ui'

import type { ReactElement } from 'react'

export function FormJoinContact(): ReactElement {
  return (
    <>
      <TextInput name="email" label="E-mail address" />
      <TextInput name="phone" label="Phone number" />
    </>
  )
}
